import { useState, useEffect } from "react";
import axios from "axios";

const API_URL = process.env.NEXT_PUBLIC_API_URL || "http://localhost:1337";

/**
 * Custom hook for fetching Strapi API data.
 *
 * @param {string} endpoint - The API endpoint (e.g., '/api/home').
 * @param {object} [params={}] - Optional query params (e.g., { populate: '*' }).
 */
export default function useFetchAPI(endpoint, params = {}) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!endpoint) return;

    const fetchData = async () => {
      try {
        setLoading(true);
        setError(null);

        const response = await axios.get(`${API_URL}${endpoint}`, {
          params,
        });

        setData(response.data?.data || response.data);
      } catch (err) {
        console.error("API Fetch Error:", err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [endpoint, JSON.stringify(params)]);

  return { data, loading, error };
}
